import { useEffect } from 'react';
import { useLang } from '../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../hooks/use-modal-params';
import { AdminType } from '../../../../../store/api/admins-api';
import { useAdminsStore } from '../../../../../store/use-admins-store';
import { useEmployeesStore } from '../../../../../store/use-employee-store';
import { useRoleStore } from '../../../../../store/use-role-store';

export const useRolesDictionary = () => {
  const { t, getLocale } = useLang();
  const { isLoading, roles, fetchRoles, deleteRole } = useRoleStore();
  const { fetchEmployees } = useEmployeesStore();
  const { list: admins, fetchAdmins, isLoading: isAdminsLoading } = useAdminsStore();

  useEffect(() => {
    fetchRoles({ is_by_company: true, n: 1000, since_id: 0 });
    fetchEmployees({ is_by_company: true, page_size: 1000, page: 1 });
    fetchAdmins({ n: 1000, since_id: 0, with_archive: true });
  }, []);

  const createRoleModal = useModalParams('createRole');
  const unattachRoleModal = useModalParams('unattachRole');

  const groupedByRoleAdmins = admins?.reduce<Record<string, AdminType[]>>((acc, admin) => {
    if (!acc[admin.role]) {
      acc[admin.role] = [];
    }
    acc[admin.role].push(admin);
    return acc;
  }, {});

  return {
    t,
    isLoading,
    roles,
    getLocale,
    deleteRole,
    createRoleModal,
    unattachRoleModal,
    groupedByRoleAdmins,
    isAdminsLoading,
  };
};
